<template>
  <!-- MARE: za mobilni da napravimo novu komponentu sa jednom slikom + logika da zauzima 2 mesta -->
  <!-- ko ubacije banner pise i alt za sliku -->
  <a :href="link" class="inline-block m_580:hidden">
    <img src="https://placehold.co/600x400/bd6609/FFFFFF/png" alt="" class="w-full" width="600" height="400" loading="lazy">
  </a>
</template>

<script>
export default {
  name: "CategoryBannerMobile",
}
</script>